export enum OfferType {
  Selection,
  Foundation,
  Internal,
}
